'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { Space } from '@s7/layout';
import { DEFAULT_TEXT_HEIGHTS, Typography } from '@s7/ui';
import { useFooterNavigationContext } from '../../FooterNavigation.context.js';
import { useLinkOverride } from '../../../../../common/ResourceLink/LinkOverride.context.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var NavigationCategoryTitle = function(props) {
    var link = props.link, title = props.title;
    var context = useFooterNavigationContext();
    var unpackLink = useLinkOverride();
    return title === false ? /*#__PURE__*/ jsx(Space, {
        height: DEFAULT_TEXT_HEIGHTS.lg1
    }) : /*#__PURE__*/ jsx(Typography, _extends({
        size: "lg1",
        weight: "semibold"
    }, unpackLink(link), {
        onClick: function(event) {
            context.onCategoryTitleClick == null ? void 0 : context.onCategoryTitleClick.call(context, {
                link: link,
                title: title
            }, event);
        },
        children: title
    }));
};

export { NavigationCategoryTitle };
